/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-refresh': {
    width: 24,
    height: 24,
    viewBox: '-8 -8 40 40',
    data: '<g><g><g><path pid="0" d="M22 4H3.414l1.793-1.793A.999.999 0 103.793.793l-3.5 3.5a.999.999 0 000 1.414l3.5 3.5a.999.999 0 101.414-1.414L3.414 6H21v5.5a1 1 0 102 0V5a1 1 0 00-1-1z"/><path pid="1" d="M23.707 18.293l-3.5-3.5a.999.999 0 10-1.414 1.414L20.586 18H3.016v-5a1 1 0 10-2 0v6a1 1 0 001 1h18.57l-1.793 1.793a.999.999 0 101.414 1.414l3.5-3.5a.999.999 0 000-1.414z"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-refresh.js